import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=bcbfd124&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=bcbfd124&prod&lang=scss"
import style1 from "./BarChart.vue?vue&type=style&index=1&id=bcbfd124&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbfd124",
  null
  
)

export default component.exports